/* eslint-disable  jsx-a11y/label-has-associated-control */ 

import React, { useEffect, useMemo, useState } from 'react';
import debounce from 'debounce';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, CircularProgress, InputAdornment } from '@material-ui/core';
import AssignDoubleScorecard from './AssignDoubleScorecard';
import UserSearchCommunity from './UserSearchCommunity';



export const TagSelector = ({
  isHackathonChallenge,
  listCommunitesChallenge,
  suggestionsList = [],
  suggestionsListByCommunity = [],
  getSuggestionsAPI,
  getSuggestionsAPIFromSearchByCommunity,
  isLoading,
  onValueChange,
  onCommunityValueChange,
  inputLabel,
  onChangeDropdownSelectValua = ()=>{},
  ArrayOfObjDoubleScorecard = [],
  ChallengeTemplateId,
  businessScoreCardTemplateId = '',
  handleChildValueOnChangeDBSC = ()=>{},
  searchMode,
  setSearchMode,
  hideCommunitySearch = false,
}) => {



  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [error, setError] = useState(null);
  const [assignScorecardId, setAssignScorecardId] = useState(null);

  useEffect(() => {
    const filteredEmails = selectedTags.map(item => item.email);
    onValueChange?.(filteredEmails);
  }, [selectedTags]);


  useEffect(() => {
    if (searchTerm.trim()) {
      const filtered = suggestionsList.filter(item =>
        item.fullname?.toLowerCase().includes(searchTerm.toLowerCase()) &&
        !selectedTags.some(tag => tag.email === item.email)
      );
      setSuggestions(filtered);
    }
  }, [suggestionsList, searchTerm, selectedTags]);
  
console.log(suggestionsList,suggestions)

  const debouncedSearch = useMemo(() => 
    debounce(async (value) => {
      try {
        if (!value.trim()) {
          setSuggestions([]);
          return;
        }

        const result = await getSuggestionsAPI?.(value); // Assuming it returns a promise
        const filtered = (result || suggestionsList).filter(item =>
          item.fullname?.toLowerCase().includes(value.toLowerCase()) &&
          !selectedTags.some(tag => tag.email === item.email)
        );

        setSuggestions(filtered);
        setError(null);
      } catch (err) {
        console.error('Error filtering suggestions:', err);
        setError('Something went wrong while searching.');
      }
    }, 300), [getSuggestionsAPI, suggestionsList, selectedTags]
  );

  useEffect(() => {
    return () => debouncedSearch.clear();
  }, [debouncedSearch]);

  const handleAssignScorecardIdChange = (e) => setAssignScorecardId(e.target.value);

  const handleInputChange = (value) => {
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handleSelect = (item) => {
    if (!selectedTags.some(tag => tag.email === item.email)) {
      setSelectedTags([...selectedTags, item]);
    }
    setSearchTerm('');
    setSuggestions([]);
  };

  const handleRemove = (item) => {
    setSelectedTags(selectedTags.filter(tag => tag.email !== item.email));
  };


  console.log("isHackathonChallenge  ", isHackathonChallenge , hideCommunitySearch)

  return (
    <div style={{paddingBottom:'5rem'}}>
      
         {/* when isHackathonChallenge is true than hide dropdown scorecard list for hackthon periods */}
         
{  isHackathonChallenge ? null :
       (!hideCommunitySearch) && ( <AssignDoubleScorecard  
          ChallengeTemplateId={ChallengeTemplateId} 
          ArrayOfObjDoubleScorecard={ArrayOfObjDoubleScorecard} 
          businessScoreCardTemplateId={businessScoreCardTemplateId}
          handleChildValueOnChangeDBSC={handleChildValueOnChangeDBSC}
          onChangeDropdownSelectValua={onChangeDropdownSelectValua}
        /> )
}

      <div>
        {!hideCommunitySearch && (
          <fieldset className="ae-radio-group">
            <legend className="sr-only">Select source</legend>
            <label className="ae-radio-option">
              <input
                type="radio"
                name="evaluatorType"
                value="user"
                checked={searchMode === "user"}
                onChange={() => {
                  setSearchMode("user");
                  onCommunityValueChange('')
                }}
              />
              <span>Search User</span>
            </label>

             <label className="ae-radio-option">
              <input
                type="radio"
                name="evaluatorType"
                value="community"
                checked={searchMode === "community"}
                onChange={() => {
                  setSearchMode("community");
                  setSelectedTags([])

                }}
              />
              <span>Search Community</span>
            </label>
          </fieldset>
          )
        }
          
        

      </div>

      {searchMode === "user" && (
        
    <div style={{ width: '100%', margin: '0 auto' }}>
      <TextField
        label={inputLabel}
        value={searchTerm}
        margin="dense"
        fullWidth
        error={!!error}
        onChange={(e) => handleInputChange(e.target.value)}
        InputProps={{
          endAdornment: isLoading ? (
            <InputAdornment position="start">
              <CircularProgress size={20} />
            </InputAdornment>
          ) : null,
        }}
      />
      {error && <div style={{ color: 'red', marginTop: '5px' }}>{error}</div>}
      
      {
      suggestions.length > 0 ? (
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          border: '1px solid #ccc',
          borderTop: 'none',
          maxHeight: '150px',
          overflowY: 'auto'
        }}>
          {suggestions.map((item) => (
            <li key={item.email}>
              <button
                type="button"
                onClick={() => handleSelect(item)}
                style={{
                  background: 'transparent',
                  border: 0,
                  cursor: 'pointer',
                  width: '100%',
                  textAlign: 'left',
                  padding: '8px'
                }}
              >
                {item.fullname} - {item?.email}
              </button>
            </li>
          ))}
        </ul>
      )
            :            
  searchTerm.trim() !== '' && (
    <div style={{ padding: '8px', color: '#999' }}>
      No search found: <strong>{searchTerm}</strong>
    </div>
  )
    
    }
      <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
        {selectedTags.map((tag) => (
          <div
            key={tag.email}
            style={{
              backgroundColor: '#007bff',
              color: '#fff',
              padding: '5px 10px',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {tag.fullname}
            <span
              role="button"
              tabIndex={0}
              onClick={() => handleRemove(tag)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleRemove(tag);
                }
              }}
              style={{
                marginLeft: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              ×
            </span>
          </div>
        ))}
      </div>
    </div>
      )}

    {searchMode === "community" && (
        // <p>community</p>
        <UserSearchCommunity 
        inputLabel="Search by community"
        getSuggestionsCommunityAPI={getSuggestionsAPIFromSearchByCommunity}
        suggestionsListByCommunity={suggestionsListByCommunity}
        listCommunitesChallenge={listCommunitesChallenge}
        onCommunityValueChange={onCommunityValueChange}
        />
    )}


    </div>
  );
};

export default TagSelector;